import React from "react";
import MuiIconInvoice from "@mui/icons-material/Description";
import MuiIconEvent from "@mui/icons-material/Event";
import MuiUploadIcon from "@mui/icons-material/Upload";
import MuiUploadFileIcon from "@mui/icons-material/UploadFile";
import MuiRequestQuoteIcon from "@mui/icons-material/RequestQuote";
import MuiContactsIcon from "@mui/icons-material/Contacts";
import MuiSwitchAccountIcon from "@mui/icons-material/SwitchAccount";
import MuiContactMailIcon from "@mui/icons-material/ContactMail";
import MuiBusinessIcon from "@mui/icons-material/Business";
import MuiAccountBalanceIcon from "@mui/icons-material/AccountBalance";
import MuiGroupIcon from "@mui/icons-material/Group";

// Source
import * as HelperSrc from "../../HelperSrc";
import ControllerSidebar from "../../controller/Sidebar";
import ControllerLocalization from "../../controller/Localization";

let isRendered = false;

export const viewMenuData: React.FC = () => {
    // Variable
    const controllerSidebar = new ControllerSidebar(isRendered);
    const controllerLocalization = new ControllerLocalization(isRendered);

    // Method
    controllerSidebar.initializeHook();
    controllerLocalization.initializeHook();

    // Render
    isRendered = true;

    if (controllerLocalization.getStorageMain) {
        return (
            <div>
                <p className="text">
                    <span className="label">- {controllerLocalization.getStorageMain.task}</span>
                </p>
                <div
                    className="icon_text"
                    data-at_id="sidebar_task_list"
                    onClick={() => {
                        if (controllerSidebar.getStorageRoute) {
                            HelperSrc.routerHistoryPush(controllerSidebar.getStorageRoute.task_list.path);
                        }
                    }}
                >
                    <MuiIconInvoice />
                    <p>{controllerLocalization.getStorageMain.list}</p>
                    <div className="description">{`${controllerLocalization.getStorageMain.task} - ${controllerLocalization.getStorageMain.list}`}</div>
                </div>
                <div
                    className="icon_text"
                    data-at_id="sidebar_task_calendar"
                    onClick={() => {
                        if (controllerSidebar.getStorageRoute) {
                            HelperSrc.routerHistoryPush(controllerSidebar.getStorageRoute.task_calendar.path);
                        }
                    }}
                >
                    <MuiIconEvent />
                    <p>{controllerLocalization.getStorageMain.calendar}</p>
                    <div className="description">{`${controllerLocalization.getStorageMain.task} - ${controllerLocalization.getStorageMain.calendar}`}</div>
                </div>
                <p className="text">
                    <span className="label">- {controllerLocalization.getStorageMain.invoice}</span>
                </p>
                <div
                    className="icon_text"
                    data-at_id="sidebar_invoice_upload"
                    onClick={() => {
                        if (controllerSidebar.getStorageRoute) {
                            HelperSrc.routerHistoryPush(controllerSidebar.getStorageRoute.invoice_upload.path);
                        }
                    }}
                >
                    <MuiUploadIcon />
                    <p>{controllerLocalization.getStorageMain.upload}</p>
                    <div className="description">{`${controllerLocalization.getStorageMain.invoice} - ${controllerLocalization.getStorageMain.upload}`}</div>
                </div>
                <div
                    className="icon_text"
                    data-at_id="sidebar_invoice_upload_list"
                    onClick={() => {
                        if (controllerSidebar.getStorageRoute) {
                            HelperSrc.routerHistoryPush(controllerSidebar.getStorageRoute.invoice_upload_list.path);
                        }
                    }}
                >
                    <MuiUploadFileIcon />
                    <p>{controllerLocalization.getStorageMain.upload}</p>
                    <p>{controllerLocalization.getStorageMain.list}</p>
                    <div className="description">{`${controllerLocalization.getStorageMain.invoice} - ${controllerLocalization.getStorageMain.upload}${controllerLocalization.getStorageMain.list}`}</div>
                </div>
                <div
                    className="icon_text"
                    data-at_id="sidebar_invoice_list"
                    onClick={() => {
                        if (controllerSidebar.getStorageRoute) {
                            HelperSrc.routerHistoryPush(controllerSidebar.getStorageRoute.invoice_list.path);
                        }
                    }}
                >
                    <MuiIconInvoice />
                    <p>{controllerLocalization.getStorageMain.list}</p>
                    <div className="description">
                        {`${controllerLocalization.getStorageMain.invoice} - ${controllerLocalization.getStorageMain.list}`}
                    </div>
                </div>
                <p className="text">
                    <span className="label">- {controllerLocalization.getStorageMain.payment_instruction}</span>
                </p>
                <div
                    className="icon_text"
                    data-at_id="sidebar_payment_pi_list"
                    onClick={() => {
                        if (controllerSidebar.getStorageRoute) {
                            HelperSrc.routerHistoryPush(controllerSidebar.getStorageRoute.payment_pi_list.path);
                        }
                    }}
                >
                    <MuiIconInvoice />
                    <p>{controllerLocalization.getStorageMain.list}</p>
                    <div className="description">
                        {`${controllerLocalization.getStorageMain.payment_instruction} - ${controllerLocalization.getStorageMain.list}`}
                    </div>
                </div>
                <div
                    className="icon_text"
                    data-at_id="sidebar_payment_fr_list"
                    onClick={() => {
                        if (controllerSidebar.getStorageRoute) {
                            HelperSrc.routerHistoryPush(controllerSidebar.getStorageRoute.payment_fr_list.path);
                        }
                    }}
                >
                    <MuiRequestQuoteIcon />
                    <p>{controllerLocalization.getStorageMain.fund_request}</p>
                    <div className="description">
                        {`${controllerLocalization.getStorageMain.payment_instruction} - ${controllerLocalization.getStorageMain.fund_request}`}
                    </div>
                </div>
                <p className="text">
                    <span className="label">- {controllerLocalization.getStorageMain.payment_data}</span>
                </p>
                <div
                    className="icon_text"
                    data-at_id="sidebar_payment_pd_list"
                    onClick={() => {
                        if (controllerSidebar.getStorageRoute) {
                            HelperSrc.routerHistoryPush(controllerSidebar.getStorageRoute.payment_pd_list.path);
                        }
                    }}
                >
                    <MuiIconInvoice />
                    <p>{controllerLocalization.getStorageMain.list}</p>
                    <div className="description">
                        {`${controllerLocalization.getStorageMain.payment_data} - ${controllerLocalization.getStorageMain.list}`}
                    </div>
                </div>
            </div>
        );
    } else {
        return <></>;
    }
};

export const viewMasterData: React.FC = () => {
    // Variable
    const controllerSidebar = new ControllerSidebar(isRendered);
    const controllerLocalization = new ControllerLocalization(isRendered);

    // Method
    controllerSidebar.initializeHook();
    controllerLocalization.initializeHook();

    // Render
    isRendered = true;

    if (controllerLocalization.getStorageMain) {
        return (
            <div className="master_data">
                <div
                    className="icon_text"
                    data-at_id="sidebar_user_client_map_list"
                    onClick={() => {
                        if (controllerSidebar.getStorageRoute) {
                            HelperSrc.routerHistoryPush(controllerSidebar.getStorageRoute.user_client_map_list.path);
                        }
                    }}
                >
                    <MuiContactsIcon />
                    <p>{controllerLocalization.getStorageMain.user_client}</p>
                    <p>{`${controllerLocalization.getStorageMain.map} ${controllerLocalization.getStorageMain.list}`}</p>
                    <div className="description">{`${controllerLocalization.getStorageMain.user_client_map} - ${controllerLocalization.getStorageMain.list}`}</div>
                </div>
                <div
                    className="icon_text"
                    data-at_id="sidebar_client_list"
                    onClick={() => {
                        if (controllerSidebar.getStorageRoute) {
                            HelperSrc.routerHistoryPush(controllerSidebar.getStorageRoute.client_list.path);
                        }
                    }}
                >
                    <MuiSwitchAccountIcon />
                    <p>{controllerLocalization.getStorageMain.client}</p>
                    <p>{controllerLocalization.getStorageMain.list}</p>
                    <div className="description">
                        {`${controllerLocalization.getStorageMain.client} - ${controllerLocalization.getStorageMain.list}`}
                    </div>
                </div>
                <div
                    className="icon_text"
                    data-at_id="sidebar_client_contact_list"
                    onClick={() => {
                        if (controllerSidebar.getStorageRoute) {
                            HelperSrc.routerHistoryPush(controllerSidebar.getStorageRoute.client_contact_list.path);
                        }
                    }}
                >
                    <MuiContactMailIcon />
                    <p>{controllerLocalization.getStorageMain.client_contact}</p>
                    <p>{controllerLocalization.getStorageMain.list}</p>
                    <div className="description">
                        {`${controllerLocalization.getStorageMain.client_contact} - ${controllerLocalization.getStorageMain.list}`}
                    </div>
                </div>
                <div
                    className="icon_text"
                    data-at_id="sidebar_payer_list"
                    onClick={() => {
                        if (controllerSidebar.getStorageRoute) {
                            HelperSrc.routerHistoryPush(controllerSidebar.getStorageRoute.payer_list.path);
                        }
                    }}
                >
                    <MuiBusinessIcon />
                    <p>{controllerLocalization.getStorageMain.payer}</p>
                    <p>{controllerLocalization.getStorageMain.list}</p>
                    <div className="description">
                        {`${controllerLocalization.getStorageMain.payer} - ${controllerLocalization.getStorageMain.list}`}
                    </div>
                </div>
                <div
                    className="icon_text"
                    data-at_id="sidebar_payee_list"
                    onClick={() => {
                        if (controllerSidebar.getStorageRoute) {
                            HelperSrc.routerHistoryPush(controllerSidebar.getStorageRoute.payee_list.path);
                        }
                    }}
                >
                    <MuiAccountBalanceIcon />
                    <p>{controllerLocalization.getStorageMain.payee}</p>
                    <p>{controllerLocalization.getStorageMain.list}</p>
                    <div className="description">
                        {`${controllerLocalization.getStorageMain.payee} - ${controllerLocalization.getStorageMain.list}`}
                    </div>
                </div>
                <div
                    className="icon_text"
                    data-at_id="sidebar_team_list"
                    onClick={() => {
                        if (controllerSidebar.getStorageRoute) {
                            HelperSrc.routerHistoryPush(controllerSidebar.getStorageRoute.team_list.path);
                        }
                    }}
                >
                    <MuiGroupIcon />
                    <p>{controllerLocalization.getStorageMain.team}</p>
                    <p>{controllerLocalization.getStorageMain.list}</p>
                    <div className="description">
                        {`${controllerLocalization.getStorageMain.team} - ${controllerLocalization.getStorageMain.list}`}
                    </div>
                </div>
            </div>
        );
    } else {
        return <></>;
    }
};
